<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col class="col-6">
                    <ValidationProvider
                        name="academic_year"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="form.academic_year"
                                :validate-error="errors[0]"
                            ></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="session" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('session')">
                            <parameter-selectbox
                                v-model="form.session"
                                :code="'esl_sessions'"
                                :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="start_date" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <select-date
                                v-model="form.start_date"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="end_date" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <select-date
                                v-model="form.end_date"
                                :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="course_registration_start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('course_registration_start_date')">
                            <select-date :is-time="true"
                                         v-model="form.course_registration_start_date"
                                         :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="course_registration_end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('course_registration_end_date')">
                            <select-date :is-time="true"
                                         v-model="form.course_registration_end_date"
                                         :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col class="col-6">
                    <ValidationProvider name="late_registration_start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('late_registration_start_date')">
                            <select-date :is-time="true"
                                         v-model="form.late_registration_start_date"
                                         :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import EslModuleDateService from "@/services/EslModuleDateService";
    import moment from "moment/moment";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            AcademicYearsSelectbox,
            ParameterSelectbox,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    academic_year: null,
                    session: null,
                    start_date: null,
                    end_date: null,
                    course_registration_start_date: null,
                    course_registration_end_date: null,
                    late_registration_start_date: null,
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                EslModuleDateService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    let formData = {
                        academic_year: this.form.academic_year,
                        session: this.form.session,
                        start_date: this.form.start_date,
                        end_date: this.form.end_date,
                        course_registration_start_date: this.form.course_registration_start_date,
                        course_registration_end_date: this.form.course_registration_end_date,
                        late_registration_start_date: this.form.late_registration_start_date,
                    }

                    EslModuleDateService.update(this.formId, formData)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            }
        }
    }
</script>
